import {isImmersiveOnboardingPhase101Enabled} from 'common/report/util/feature-sampling';
import {CurrentProject} from 'common/report/model-resources/projects';
import {hotjarIdentify} from 'common/util/hotjar';

export const isPhase101Enabled = (project: CurrentProject): boolean => {
  const enabled = isImmersiveOnboardingPhase101Enabled(project);

  // Add user prop to segment hotjar
  hotjarIdentify({'immersive-onboarding-v1-1': enabled});

  return enabled;
};
